import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorViewModel } from '../../models/error-view.model';

@Component({
  selector: 'app-error',
  imports: [CommonModule],
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {

  @Input() errorViewModel: ErrorViewModel = new ErrorViewModel;
  
  constructor() { }

  ngOnInit() {
  }

}
